import { trackWidgetSeen } from './analytics.service.js'

interface VisibilityTrackerOptions {
  projectId: string
  element: HTMLElement
  threshold?: number
  rootMargin?: string
}

export class VisibilityTracker {
  private projectId: string
  private element: HTMLElement
  private observer: IntersectionObserver | null = null
  private hasBeenSeen = false
  private isCurrentlyVisible = false

  constructor({ projectId, element, threshold = 0.7, rootMargin = '0px' }: VisibilityTrackerOptions) {
    this.projectId = projectId
    this.element = element
    this.initObserver(threshold, rootMargin)
  }

  private initObserver(threshold: number, rootMargin: string): void {
    if (!window.IntersectionObserver) {
      console.warn('IntersectionObserver not supported, visibility tracking disabled')
      return
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.handleVisibilityChange(entry.isIntersecting)
        })
      },
      {
        threshold,
        rootMargin,
        root: null // Use viewport as root
      }
    )

    this.observer.observe(this.element)
  }

  private handleVisibilityChange(isIntersecting: boolean): void {
    this.isCurrentlyVisible = isIntersecting
    
    // Only track "seen" once when widget first becomes visible
    if (isIntersecting && !this.hasBeenSeen) {
      this.hasBeenSeen = true
      trackWidgetSeen(this.projectId)
    }
  }

  // Check if iframe has been seen at least once
  public hasIframeBeenSeen(): boolean {
    return this.hasBeenSeen
  }

  // Check if iframe is currently visible
  public isIframeCurrentlyVisible(): boolean {
    return this.isCurrentlyVisible
  }



  // Clean up observer
  public destroy(): void {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
  }
} 